import { useContextState } from '../../../../hooks/theme'

export const useStyles = () => {
  const { colors } = useContextState()
  return {
    container: {
      width: '100%',
      height: '100%',
      paddingTop: '50px',
      paddingLeft: '10px',
      paddingRight: '40px',
      paddingBottom: '20px',
      overflowY: 'auto',
      overflowX: 'hidden',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '20px',
    },
    title: {
      fontSize: '22px',
      fontWeight: '600',
      color: colors.color9,
    },
    headerInfo: {
      display: 'flex',
      gap: '30px',
      alignItems: 'center',
    },
    headerInfoItem: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
    },
    headerInfoLabel: {
      fontSize: '12px',
      color: colors.color10,
      textTransform: 'uppercase',
    },
    headerInfoValue: {
      fontWeight: '600',
      fontSize: '15px',
      color: colors.color22,
    },
    stepWrapper: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      border: `1px solid ${colors.color39}`,
      borderRadius: '4px',
      overflow: 'hidden',
      minHeight: 0,
    },
    stepHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '20px 30px',
      backgroundColor: colors.color14,
      borderBottom: `1px solid ${colors.color39}`,
      flexShrink: 0,
    },
    stepHeaderLeft: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '14px',
    },
    stepHeaderIconWrapper: {
      width: '38px',
      height: '38px',
      borderRadius: '8px',
      backgroundColor: `${colors.primary}18`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    },
    stepHeaderIcon: {
      fontSize: '22px',
      color: colors.primary,
    },
    stepHeaderQuestionnaireName: {
      fontWeight: '600',
      fontSize: '16px',
      color: colors.color22,
    },
    stepHeaderRight: {
      display: 'flex',
      gap: '30px',
      alignItems: 'center',
    },
    stepContent: {
      flex: 1,
      overflowY: 'auto',
      minHeight: 0,
    },
    stepFooter: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '12px 20px',
      borderTop: `1px solid ${colors.color39}`,
      flexShrink: 0,
    },
    cardContainer: {
      padding: '20px',
      margin: '0px',
      boxShadow: 'none',
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      overflow: 'hidden',
      minHeight: 0,
    },
    userSectionContainer: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: 0,
      overflow: 'hidden',
      marginTop: '16px',
      borderRadius: '2px',
      boxShadow: `0px 0px 2px 1px ${colors.color3}`,
    },
    userSectionHeader: {
      padding: '8px 16px',
      backgroundColor: colors.color14,
      borderBottom: `1px solid ${colors.color39}`,
      marginBottom: '10px',
    },
    twoColumnContainer: {
      display: 'flex',
      gap: '20px',
      marginTop: '20px',
    },
    leftColumn: {
      flex: 1,
      minWidth: 0,
    },
    rightColumn: {
      flex: 1,
      minWidth: 0,
    },
    step1TwoColumnContainer: {
      display: 'flex',
      height: '100%',
      width: '100%',
    },
    step1LeftColumn: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      boxShadow: `0px 0px 2px 1px ${colors.color3}`,
      overflow: 'hidden',
      minHeight: 0,
    },
    step1RightColumn: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      boxShadow: `0px 0px 2px 1px ${colors.color3}`,
      overflow: 'hidden',
      minHeight: 0,
    },
    cardTitle: {
      fontSize: '16px',
      fontWeight: '600',
      color: colors.color22,
    },
    userListContainer: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      overflowY: 'auto',
      padding: '0 17px 10px 17px',
      gap: '8px',
    },
    userItem: {
      display: 'flex',
      alignItems: 'center',
      padding: '8px 8px 8px 6px',
      gap: '6px',
      borderRadius: '4px',
      border: `1px solid ${colors.color39}`,
      '&:hover': {
        backgroundColor: colors.ashBlue,
      },
    },
    userCheckbox: {
      padding: '0px',
    },
    userItemInfo: {
      flex: 1,
      minWidth: 0,
      display: 'flex',
      flexDirection: 'column',
    },
    userItemName: {
      fontSize: '14px',
      fontWeight: '500',
      color: colors.color13,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    userItemDetail: {
      fontSize: '12px',
      color: colors.color10,
      marginTop: '2px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    searchContainer: {
      padding: '0 17px',
      marginBottom: '10px',
    },
    searchContainerStep3: {
      padding: '0',
      marginBottom: '12px',
    },
    cardHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '16px',
    },
    filterButton: {
      color: colors.color4,
    },
    userFilterButton: {
      backgroundColor: colors.color31,
      color: colors.color5,
      borderRadius: '4px',
      padding: '6px',
      '&:hover': {
        backgroundColor: `${colors.color31}99`,
      },
      '& svg': {
        color: colors.color5,
      },
    },
    userSectionTitle: {
      fontSize: '16px',
      fontWeight: '500',
      color: colors.color10,
    },
    noData: {
      fontSize: '14px',
      color: colors.color10,
      textAlign: 'center',
      padding: '24px 0',
    },
    noEvidencesMessage: {
      fontSize: '14px',
      color: colors.color10,
      textAlign: 'center',
      padding: '40px 0',
      margin: 'auto',
    },
    filterModalTitle: {
      fontSize: '22px',
      fontWeight: '600',
      color: colors.color9,
    },
    filterModalContainer: {
      padding: '50px 60px',
      minWidth: '400px',
      position: 'relative',
    },
    filterModalHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '20px',
      position: 'relative',
    },
    filterModalClose: {
      position: 'absolute',
      top: '-35px',
      right: '-50px',
      '&.MuiSvgIcon-root': {
        fontSize: '2rem',
      },
    },
    filterModalButton: {
      marginTop: '20px',
      backgroundColor: colors.color8,
      color: colors.color5,
      fontWeight: '500',
      padding: '5px 20px',
      '&:hover': {
        backgroundColor: `${colors.color8}ee`,
      },
    },
    buttonsContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '20px',
      paddingBottom: '20px',
    },
    // kept for potential reuse
    step2Container: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    },
    questionListContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      padding: '20px',
      flex: 1,
      overflowY: 'auto',
      minHeight: 0,
    },
    questionItem: {
      display: 'flex',
      alignItems: 'flex-start',
      padding: '16px',
      backgroundColor: colors.ashBlue,
      borderRadius: '4px',
      gap: '16px',
    },
    questionCheckbox: {
      padding: '0px',
      marginTop: '2px',
    },
    questionContent: {
      flex: 1,
      display: 'flex',
      justifyContent: 'space-between',
      gap: '16px',
    },
    questionLeft: {
      flex: 1,
    },
    questionRight: {
      flex: 1,
    },
    questionLabel: {
      fontSize: '12px',
      color: colors.color10,
      marginBottom: '4px',
    },
    questionText: {
      fontSize: '14px',
      color: colors.color13,
      lineHeight: 1.4,
    },
    answerText: {
      fontSize: '14px',
      color: colors.color13,
      lineHeight: 1.4,
      wordBreak: 'break-word',
    },
    step3Container: {
      display: 'flex',
      height: '100%',
      gap: '0px',
      overflow: 'hidden',
    },
    step3LeftColumn: {
      width: '35%',
      borderRight: `1px solid ${colors.color39}`,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    },
    step3RightColumn: {
      width: '65%',
      padding: '8px 20px',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      minHeight: 0,
    },
    questionsHeader: {
      display: 'flex',
      alignItems: 'center',
      padding: '8px 20px',
      backgroundColor: colors.color14,
      borderBottom: `1px solid ${colors.color3}`,
    },
    columnHeader: {
      fontSize: '16px',
      fontWeight: '500',
      color: colors.color13,
    },
    questionsContent: {
      display: 'flex',
      flexDirection: 'column',
      padding: '12px 12px',
      flex: 1,
      overflowY: 'auto',
      minHeight: 0,
    },
    questionList: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      flex: 1,
      overflowY: 'auto',
      minHeight: 0,
    },
    questionItemSelectable: {
      padding: '12px',
      borderRadius: '4px',
      cursor: 'pointer',
      border: `1px solid ${colors.color39}`,
      transition: 'all 0.2s',
      '&:hover': {
        backgroundColor: `${colors.ashBlue}40`,
      },
    },
    questionItemSelected: {
      backgroundColor: colors.ashBlue,
    },
    questionItemText: {
      fontSize: '14px',
      color: colors.color22,
      marginBottom: '4px',
    },
    questionItemAnswerLabel: {
      fontSize: '12px',
      color: colors.color10,
    },
    questionItemAnswerValue: {
      fontSize: '12px',
      color: colors.color13,
      wordBreak: 'break-word',
    },
    evidencesHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '8px',
    },
    expandAllButton: {
      color: colors.color4,
      fontSize: '14px',
      textTransform: 'none',
    },
    evidencesList: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      overflowY: 'auto',
      padding: '10px',
    },
    accordionWrapper: {
      marginBottom: '10px',
      '& .MuiAccordion-root': {
        boxShadow: `0px 2px 3px ${colors.color22}`,
        borderRadius: '10px',
        '&:before': {
          display: 'none',
        },
      },
      '& .MuiAccordionSummary-root': {
        minHeight: '48px',
        padding: '0 16px',
      },
      '& .MuiAccordionSummary-root.Mui-expanded': {
        minHeight: '48px',
        margin: '0px',
      },
      '& .MuiAccordionSummary-content': {
        margin: '0px',
      },
      '& .MuiAccordionSummary-content.Mui-expanded': {
        margin: '0px',
      },
      '& .MuiCollapse-root': {
        maxHeight: 'none !important',
      },
      '& .MuiCollapse-wrapper': {
        maxHeight: 'none !important',
      },
      '& .MuiAccordionDetails-root': {
        maxHeight: 'none',
        overflow: 'visible',
        borderTop: `2px solid ${colors.color32}`,
      },
    },
    accordionTitleText: {
      fontSize: '16px',
      color: colors.color22,
    },
    accordionBadge: {
      backgroundColor: colors.color9,
      color: colors.color5,
      borderRadius: '50%',
      width: '30px',
      height: '30px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '16px',
      marginRight: '20px',
    },
    accordionTitle: {
      display: 'flex',
      alignItems: 'center',
      flex: 1,
    },
    accordionSelectedCount: {
      marginLeft: 'auto',
      fontSize: '12px',
      color: colors.color10,
      marginRight: '8px',
    },
    selectAllRow: {
      display: 'flex',
      alignItems: 'center',
    },
    selectAllText: {
      fontSize: '14px',
      fontWeight: '500',
      color: colors.color4,
      cursor: 'pointer',
    },
    evidenceGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 1fr)',
      gap: '16px',
      padding: '14px 0',
    },
    evidenceItem: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
    },
    evidenceCheckboxAbsolute: {
      padding: '0',
      margin: '0',
    },
    evidencePreview: {
      width: '180px',
      height: '150px',
      marginTop: '2px',
      backgroundColor: colors.color25,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '4px',
      position: 'relative',
    },
    evidenceExpand: {
      position: 'absolute',
      bottom: '2px',
      right: '2px',
      width: '35px',
      height: '35px',
      margin: '0 5px',
      padding: '0',
      color: colors.color5,
    },
    evidenceImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    evidenceIcon: {
      fontSize: '32px',
      color: colors.color4,
    },
    evidenceList: {
      display: 'flex',
      flexDirection: 'column',
      padding: '10px 0',
    },
    evidenceListItem: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '12px 10px 2px 10px',
      borderBottom: `2px solid ${colors.color10}`,
    },
    evidenceListItemContent: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
    },
    evidenceListItemName: {
      flex: 1,
      fontSize: '16px',
      color: colors.color22,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    evidenceListItemView: {
      display: 'flex',
      alignItems: 'center',
      color: colors.color4,
      padding: '4px',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    modalConfirmation: {
      width: '400px',
      paddingTop: '6px',
      borderRadius: '8px',
    },
    notificationsContainer: {
      padding: '20px 20px',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },
    notificationsTitle: {
      fontSize: '18px',
      fontWeight: '600',
      color: colors.color9,
    },
    notificationsSubtitle: {
      fontSize: '14px',
      color: colors.color10,
    },
    notificationsSection: {
      display: 'flex',
      flexDirection: 'column',
      marginTop: '20px',
    },
    notificationsSectionTitle: {
      fontSize: '16px',
      fontWeight: '600',
      color: colors.color13,
    },
    notificationsSectionHelper: {
      fontSize: '14px',
      color: colors.color10,
      marginBottom: '4px',
    },
    internalUsersSelectContainer: {
      marginTop: '12px',
      width: '30%',
      minWidth: '250px',
    },
  }
}